import React from "react";
import CustomTable from "../../components/CustomTable";
import { getGenre, getRbac, getStates } from "../../../services/CommonServices";
import {
  genreValidationSchema,
  rbacValidationSchema,
} from "../../../utils/validationSchemas/MasterDataSchema";
import AddUpdateRbac from "./AddUpdate.jsx";

const Rbac = () => {
  const columns = [
    {
      label: "#",
      render: (row, index, currentPage, pageSize) => (
        <span>{(currentPage - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      label: "Role",
      key: "title",
    },
    {
      label: "Access Levels",
      render: (row, index) => <span>{row.access.join(", ")}</span>,
    },
  ];
  const modalConfig = {
    initialValues: {
      acccess: [],
      title: "",
    },
    validationSchema: rbacValidationSchema,
    apiUrl: "rbac",
    FormComponent: AddUpdateRbac,
    addTitle: "Add Rbac",
    updateTitle: "Update Rbac",
    extraProps: {},
  };
  return (
    <CustomTable
      formModal={true}
      title="UNM Roles & Access"
      addBtnTitle="Add New Role"
      columns={columns}
      getHook={getRbac}
      store={"rbac"}
      deleteHook={"rbac"}
      modalConfig={modalConfig}
    />
  );
};

export default Rbac;
